module.exports = __webpack_public_path__ + "img/appAsset--suppliers-ax.c5d208c1.svg";